"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagMW = function FlagMW(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H209.54a7.06,7.06,0,0,1,7.06,7.06v82.39H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M66.67-41A63.49,63.49,0,0,0,11.8-72.57,63.49,63.49,0,0,0-43.07-41Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.45-102.58c0,3.17-3.65,23-3.65,23s-3.65-19.78-3.65-23,1.64-5.74,3.65-5.74,3.65,2.57,3.65,5.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M80.39-72.66C78.15-70.42,61.58-59,61.58-59S73-75.58,75.23-77.82s5.21-2.9,6.64-1.47.76,4.39-1.48,6.63Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-51.63-77.82C-49.39-75.57-38-59-38-59S-54.55-70.42-56.79-72.66s-2.9-5.21-1.48-6.64,4.4-.76,6.64,1.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-20.56-96.87c1.22,2.93,5.42,22.6,5.42,22.6s-10.94-16.88-12.15-19.8-.69-5.93,1.17-6.7,4.35,1,5.56,3.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50.89-94.08c-1.21,2.93-12.15,19.81-12.15,19.81s4.2-19.67,5.41-22.6,3.71-4.68,5.57-3.9,2.39,3.77,1.17,6.69Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-3.18-101.44c.63,3.1,1,23.22,1,23.22S-9.7-96.89-10.33-100s.46-6,2.43-6.35,4.09,1.79,4.72,4.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M66.41-85c-1.75,2.65-15.72,17.12-15.72,17.12s7.89-18.5,9.64-21.15,4.53-3.88,6.21-2.76,1.62,4.15-.13,6.79Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-64-63.84c2.64,1.75,17.12,15.72,17.12,15.72S-65.39-56-68-57.76-71.91-62.29-70.8-64s4.16-1.62,6.8.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-37.33-88.69c1.77,2.63,9.8,21.07,9.8,21.07S-41.61-82-43.38-84.61s-1.85-5.68-.18-6.8,4.46.09,6.23,2.72Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M91.26-58.36c-2.63,1.77-21.07,9.8-21.07,9.8s14.37-14.08,17-15.85,5.68-1.85,6.8-.18-.09,4.47-2.72,6.23Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.25-100.16c-.61,3.11-8,21.83-8,21.83s.2-20.11.81-23.22,2.7-5.32,4.68-4.93,3.08,3.21,2.48,6.32Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M35.42-99.61c-.92,3-3.17,23-3.17,23S41.48-94.46,42.41-97.5s.1-6-1.83-6.55-4.24,1.41-5.16,4.44Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-35.41-89.84c1.5,2.79,14,18.52,14,18.52s-6.1-19.17-7.59-22-4.15-4.28-5.93-3.33-2,4-.51,6.78Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M92.42-56.44c-2.8,1.5-18.53,14-18.53,14s19.17-6.11,22-7.6,4.29-4.14,3.34-5.92-4-2-6.78-.52Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M68.21-83.7c-2,2.46-11.74,20.06-11.74,20.06s15.37-13,17.39-15.42,2.37-5.48.82-6.75-4.45-.33-6.47,2.11Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-62.66-65.64c2.44,2,20,11.74,20,11.74S-55.59-69.27-58-71.28s-5.47-2.38-6.75-.83-.33,4.46,2.13,6.47Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-1-101.77c.31,3.15,5.88,22.48,5.88,22.48s1.7-20,1.39-23.2S4.11-108,2.1-107.84s-3.37,2.91-3.07,6.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.45-102.48c-.32,3.15,1.35,23.2,1.35,23.2s5.59-19.32,5.91-22.47-1.05-5.87-3.06-6.08-3.88,2.2-4.2,5.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-50.15-79.16c2,2.45,17.36,15.45,17.36,15.45s-9.7-17.62-11.71-20.07-4.9-3.41-6.45-2.13-1.2,4.3.8,6.75Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M81.73-71.17c-2.45,2-15.45,17.36-15.45,17.36S83.9-63.52,86.35-65.52s3.41-4.9,2.13-6.46-4.29-1.2-6.75.81Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M52.7-93.22c-1.49,2.79-7.63,22-7.63,22S57.64-87,59.14-89.77s1.27-5.83-.51-6.78S54.2-96,52.7-93.22Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-72.19-50.13c2.79,1.5,21.95,7.63,21.95,7.63s-15.71-12.57-18.5-14.06-5.83-1.28-6.78.5.54,4.43,3.33,5.93Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-18.67-97.54c.92,3,10.13,20.92,10.13,20.92s-2.23-20-3.14-23-3.22-5-5.15-4.44-2.75,3.51-1.84,6.55Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagMW;
exports["default"] = _default;